import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/system'
import { Chip, LinearProgress } from '@mui/material'
import Physics from '../../../../../assets/icons/courses/Physics.svg'
import { BoldText, H6 } from '../../../../../layouts/TextStyles'

const styles = {
    wrapper: {
        display: 'flex',
        maxWidth: '1000px',
        width: '100%',
        height: '90px',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '2px solid #F1F3F5',
        cursor: 'pointer',
        mb: 2,
        mr: 2,
    },
    logo: {
        width: '130px',
        height: '90px',
    },
    main: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        padding: '16px 24px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        mr: 2,
    },
}

const SubjectProgressCard = () => {
    const navigate = useNavigate()
    const { formatMessage } = useIntl()

    return (
        <Box
            sx={styles.wrapper}
            onClick={() => navigate('/progress/5/6/5')}
        >
            <Box sx={styles.logo}>
                <img
                    src={Physics}
                    style={{ height: '90px' }}
                />
            </Box>

            <Box sx={styles.main}>
                <Box sx={styles.content}>
                    <Box mb={1}>
                        <H6>Физика</H6>
                    </Box>

                    <Box mb={1}>
                        <LinearProgress
                            value={70}
                            variant="determinate"
                            sx={{ width: '100%' }}
                        />
                    </Box>

                    <Box>
                        <BoldText>5 {formatMessage({ id: 'topics' })}</BoldText>
                    </Box>
                </Box>

                <Box>
                    <Chip label="70%" />
                </Box>
            </Box>
        </Box>
    )
}

export default SubjectProgressCard
